"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeDividerStyles = void 0;

var makeDividerStyles = function makeDividerStyles(_ref) {
  var tokens = _ref.tokens;
  return {
    MuiDivider: {
      styleOverrides: {
        root: tokens.divider.strong,
        light: tokens.divider.default
      }
    }
  };
};

exports.makeDividerStyles = makeDividerStyles;